import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import { auth } from '@/fireinit'
import store from '@/store';
// import ui from '@/store/modules/ui'

// Code Splitting: Lazy Loading the components
// Components
const PolicyComponent = () => import('@/components/PolicyComponent.vue');

// Main views
const About = () => import('@/views/About.vue');
const Search = () => import('@/views/Search.vue');
const Event = () => import('@/views/Event.vue');
const Category = () => import('@/views/Category.vue');
const Venue = () => import('@/views/Venue.vue');

// Event
const EventView = () => import('@/views/event/EventView.vue')
const BuyModal = () => import('@/views/event/BuyModal.vue')
const CreateEventMail = () => import('@/views/event/CreateEventMail.vue')

// Venue
const VenueView = () => import('@/views/venue/VenueView.vue')

// Payment
const Payment = () => import('@/views/payment/Payment.vue');
const EventRules = () => import('@/components/payment/EventRules.vue')
const CustomerInfo = () => import('@/components/payment/CustomerInfo.vue')
const CardInfo = () => import('@/components/payment/CardInfo.vue')


// Auth views
const SignIn = () => import('@/views/auth/SignIn.vue');
const SignUp = () => import('@/views/auth/SignUp.vue');
const ResetPw = () => import('@/views/auth/ResetPw.vue');
const ChooseUsername = () => import('@/views/auth/ChooseUsername.vue');
const UserManagement = () => import('@/views/auth/UserManagement.vue');

// User views
const UserProfile = () => import('@/views/user/UserProfile.vue');
const UserNotification = () => import('@/views/user/UserNotification.vue');
const UserFavorite = () => import('@/views/user/UserFavorite.vue');
const AccountSettings = () => import('@/views/user/AccountSettings.vue');
const PersonalInfo = () => import('@/views/user/PersonalInfo.vue');

Vue.use(Router)



const scrollBehavior = function (to, from, savedPosition) {
  // console.log('route to name', to.name);
  // if (to.name === 'home' && savedPosition) {
  //   console.log('returning saved piostion');
  //   return savedPosition
  // }
  // console.log('if home not runs rest');
  if (savedPosition) {
    return savedPosition
  } else {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/c/:cityName',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      component: About
    },
    {
      path: '/search',
      name: 'search',
      // route level code-splitting
      component: Search
    },
    {
      path: '/event',
      name: 'event',
      // route level code-splitting
      component: Event,
      children: [
        {
          path: ':eventID',
          name: 'event-view',
          component: EventView,
          props: true
        },
        {
          path: ':eventID/buy-modal',
          name: 'event-view-buy-modal',
          component: BuyModal,
        }
      ]
    },
    // Create
    {
      path: 'create-by-mail',
      name: 'create-event-by-mail',
      component: CreateEventMail,
    },
    // Category
    {
      path: '/c/:cityName/events/:slug',
      name: 'events',
      // route level code-splitting
      component: Category,
      props: {},
      // children: [
      //     {
      //       path: ':subtype',
      //       name: 'events-subtype-view',
      //       component: VenueView,
      //     }, 
      // ]
    },
    // VENUE
    {
      path: '/venue',
      name: 'venue',
      // route level code-splitting
      component: Venue,
      children: [
        {
          path: ':venueID',
          name: 'venue-view',
          component: VenueView,
        },
      ]
    },
    // Payment
    {
      path: '/payment',
      name: 'payment',
      component: Payment,
      beforeEnter: function (to, from, next) {
        next()
      },
      children: [
        {
          path: 'event-rules',
          name: 'payment-event-rules',
          component: EventRules,
        },
        {
          path: 'customer-info',
          name: 'payment-customer-info',
          component: CustomerInfo,
          beforeEnter: function (to, from, next) {
            !store.state.user.userDoc.userBasket.eventRulesIsAccepted
              ? next(false)
              : next()
          }
        },
        {
          path: 'card-info',
          name: 'payment-card-info',
          component: CardInfo,
          beforeEnter: function (to, from, next) {
            // enter this page only if conditions and customer data
            // are accepted and confirmed.
            !store.state.user.userDoc.userBasket.eventRulesIsAccepted
              || !store.state.user.userDoc.userBasket.customerInfo.isConfirmed
              ? next(false)
              : next()
          }
        }
      ]
    },
    // AUTH
    {
      path: '/auth/signin',
      name: 'signin',
      component: SignIn,
      meta: {
        isAuthPath: true
      }
    },
    {
      path: '/auth/signup',
      name: 'signup',
      component: SignUp,
      meta: {
        isAuthPath: true
      }
    },
    {
      path: '/auth/reset-pw',
      name: 'reset-pw',
      component: ResetPw
    },
    {
      path: '/auth/choose-username',
      name: 'choose-username',
      component: ChooseUsername
    },
    {
      path: '/auth/usermgmt/action',
      name: 'user-management',
      component: UserManagement
    },
    // ./AUTH
    {
      path: '/help',
      name: 'help',
      component: PolicyComponent
    },
    // USER
    {
      path: '/account-settings',
      name: 'account-settings',
      component: AccountSettings,
      meta: {
        authentication: true,
      },
    },
    {
      path: '/personal-info',
      name: 'personal-info',
      component: PersonalInfo,
      meta: {
        authentication: true,
      },
    },
    {
      path: '/:slug',
      name: 'user-profile',
      component: UserProfile,
      meta: {
        authentication: true,
      },
    },
    {
      path: '/:slug/notification',
      name: 'notifications',
      component: UserNotification,
      meta: {
        authentication: true,
      },
    },
    {
      path: '/:slug/favorite',
      name: 'favorite',
      component: UserFavorite,
      meta: {
        authentication: false,
      },
    },
    // ./USER
    // ------
    {
      path: "/",
      redirect: "/c/Ankara"
    },
    {
      path: "*",
      redirect: "/"
    }

  ]
})


// router.beforeResolve((to, from, next) => {
//   if (to.name) {
//       this.$Progress.start()
//   }
//   next()
// })

// router.afterEach((to, from) => {
//   this.$Progress.done()
// })


router.beforeEach((to, from, next) => {

  // this.$app.$Progress.start()
  store.commit("ui/TOGGLE_MENU", false)

  if (process.env.NODE_ENV === 'development') {
    console.log('[router]:', 'her seferinde calismiyoe mu?')
    console.log('[router]: to name', to.name);
  }

  // save scroll position of home component
  // if (from.name === 'home'){
  //   store.commit('ui/SET_HOME_SCROLL_POSITION')
  // }

  // set route cache
  // store.commit("ui/SET_ROUTE_NAME_CACHE", { from, to })

  // check if there is auth user
  const logged = auth.currentUser && !auth.currentUser.isAnonymous
  const requiresAuth = to.matched.some(
    currentMatchedRoute => currentMatchedRoute.meta.authentication
  )

  if (requiresAuth && !logged) {
    // alert(`You have to register in order to access ${to.matched[0].path}.`)

    if (process.env.NODE_ENV === 'development') {
      console.log('trying to reach to an auth path without auth')
    }
    next('/auth/signin')
    return
  }


  /**
   * IS IT IOS?
   */
  if (navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
  ) {
    // console.log('is IOS , run away');
  }


  next();
})

export default router